import { Component, OnInit, inject } from '@angular/core'
import { ConfigurablePageComponent } from 'src/app/core/abstracts/configurable-page.component'
import { IAsset } from 'src/app/core/interfaces/asset.interface'
import { ShippingBannerComponent } from 'src/app/components/shipping-banner/shipping-banner.component'
import { BreadcrumbsComponent } from 'src/app/components/breadcrumbs/breadcrumbs.component'
import { HistoryService } from 'src/app/core/services/history.service'
import { EventService } from 'src/app/core/services/event.service'
import { SeoService } from 'src/app/core/services/seo.service'
import { scrollToTop } from 'src/app/core/utils/scroll-to-top.util'
import { Router } from '@angular/router'
import { RoutePaths } from 'src/app/core/data/route-paths.data'
import { GlobalDataService } from 'src/app/core/services/global-data.service'
import { ImageSizes } from 'src/app/core/interfaces/media-library.interface'
import { TrackingService, UserEvent } from 'src/app/core/services/tracking.service'
import { CommonModule } from '@angular/common'
import { MatButtonModule } from '@angular/material/button'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatIconModule } from '@angular/material/icon'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { DetailsCarouselComponent } from 'src/app/components/details-carousel/details-carousel.component'
import { DetailsInformationComponent } from 'src/app/components/details-information/details-information.component'
import { DetailsStickyHeaderComponent } from 'src/app/components/details-sticky-header/details-sticky-header.component'
import { FooterComponent } from 'src/app/components/footer/footer.component'
import { HeaderComponent } from 'src/app/components/header/header.component'
import { LegalTermsComponent } from 'src/app/components/legal-terms/legal-terms.component'
import { QuickLinksBannerComponent } from 'src/app/components/quick-links-banner/quick-links-banner.component'
import { RecentlyViewedCarouselComponent } from 'src/app/components/recently-viewed-carousel/recently-viewed-carousel.component'
import { SimilarCarouselComponent } from 'src/app/components/similar-carousel/similar-carousel.component'
import { ErrorComponent } from 'src/app/components/error/error.component'

declare global {
  interface Window {
    gtag: any
  }
}
@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['../../../assets/page.scss', './details.component.scss'],
  providers: [
    ShippingBannerComponent,
    BreadcrumbsComponent,
    SeoService,
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatExpansionModule,
    MatIconModule,
    MatSlideToggleModule,
    HeaderComponent,
    FooterComponent,
    ShippingBannerComponent,
    BreadcrumbsComponent,
    DetailsCarouselComponent,
    DetailsInformationComponent,
    DetailsStickyHeaderComponent,
    SimilarCarouselComponent,
    RecentlyViewedCarouselComponent,
    QuickLinksBannerComponent,
    LegalTermsComponent,
    ErrorComponent,
  ],
})

export class DetailsComponent extends ConfigurablePageComponent implements OnInit {
  private _trackingService = inject(TrackingService)
  private _historyService = inject(HistoryService)
  private _eventService = inject(EventService)
  private _seoService = inject(SeoService)
  private _router = inject(Router)
  protected globalData = inject(GlobalDataService)
  window = inject(Window)

  asset!: IAsset
  watermarkLogo!: string
  leadFormConfig: any

  ngOnInit() {
    const config = this.globalDataService.config()
    this.pageConfig.set(config.page.details)
    this.watermarkLogo = config.general.data.watermark_logo ? config.header?.data?.logo?.src_data?.urls?.[ImageSizes.Thumbnail] : undefined
    this.leadFormConfig = this.pageConfig().components.leadForm.data
    this.activatedRoute.data.subscribe(
      ({ asset }) => {
        // if asset is empty, redirect to 404
        if (!asset || (Object.keys(asset).length === 0 && asset.constructor === Object)) {
          this._router.navigate(['/404'])
          return
        }
        this.asset = asset as IAsset
        this.validateEquipmentNumber(this.asset.equipment_number)
        this._historyService.addVisitedAsset(this.asset.equipment_number)
        this._seoService.init(
          config.seo.data,
          this.pageConfig().seo.data,
          this.asset,
        )
        this._trackingService.trackEvent(UserEvent.FleetAssetId, {
          fleet_asset_id: asset.fleet_asset_id
        })
        this._trackingService.trackEvent(UserEvent.ClientIdRouseSales, {
          client_id_rouse_sales: asset.client_id_rouse_sales
        })
        scrollToTop()
      }
    )
  }

  validateEquipmentNumber(equipmentNumber: string): void {
    if (!equipmentNumber) {
      this._router.navigate(['/404'])
    }

    const urlEquipmentNumber = this.activatedRoute.snapshot.params.assetId
    if (equipmentNumber !== urlEquipmentNumber) {
      this._router.navigate([RoutePaths.Details, equipmentNumber])
    }
  }

  cardClicked(assetId: string) {
    this._router.navigate([RoutePaths.Details, assetId])
  }

  contactClicked(asset: IAsset): void {
    this._eventService.notify('contactClicked', asset)
  }

}
